// ── CART COUNT ──
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    });
}

// ── CART DRAWER ──
function openCart() {
  fetchCartDrawer();
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}
function fetchCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });
}
function renderCartDrawer(cart) {
  var itemsEl = document.getElementById('cart-drawer-items');
  var footerEl = document.getElementById('cart-drawer-footer');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div style="text-align:center;padding:60px 20px;color:var(--text-muted);font-family:\'Cormorant Garamond\',serif;font-style:italic;font-size:16px;">Your cart is empty.<br><br><a href="/collections/all" style="font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:9px;letter-spacing:3px;text-transform:uppercase;color:var(--gold);border:1px solid var(--gold);padding:10px 20px;display:inline-block;margin-top:8px;">Shop Collection</a></div>';
    footerEl.innerHTML = '';
    return;
  }

  itemsEl.innerHTML = cart.items.map(function(item) {
    return '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--border);">' +
      (item.image ? '<img src="' + item.image + '" style="width:72px;height:72px;object-fit:cover;flex-shrink:0;border:1px solid var(--border);">' : '<div style="width:72px;height:72px;background:var(--ivory-deep);flex-shrink:0;display:flex;align-items:center;justify-content:center;color:var(--gold);">✦</div>') +
      '<div style="flex:1;min-width:0;">' +
        '<div style="font-family:\'Cinzel\',serif;font-size:11px;letter-spacing:3px;color:var(--black);text-transform:uppercase;margin-bottom:3px;">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:9px;letter-spacing:2px;text-transform:uppercase;color:var(--text-muted);margin-bottom:6px;">' + item.variant_title + '</div>' : '') +
        '<div style="font-family:\'Cinzel\',serif;font-size:13px;color:var(--gold-dark);margin-bottom:10px;">$' + (item.final_line_price / 100).toFixed(2) + '</div>' +
        '<div style="display:flex;align-items:center;gap:0;border:1px solid var(--border);width:fit-content;">' +
          '<button onclick="drawerUpdateItem(\'' + item.key + '\',' + (item.quantity - 1) + ')" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:16px;color:var(--gold-dark);background:none;border:none;cursor:pointer;">−</button>' +
          '<span style="width:32px;height:28px;display:flex;align-items:center;justify-content:center;font-family:\'Cinzel\',serif;font-size:12px;border-left:1px solid var(--border);border-right:1px solid var(--border);">' + item.quantity + '</span>' +
          '<button onclick="drawerUpdateItem(\'' + item.key + '\',' + (item.quantity + 1) + ')" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:16px;color:var(--gold-dark);background:none;border:none;cursor:pointer;">+</button>' +
        '</div>' +
        '<button onclick="drawerUpdateItem(\'' + item.key + '\',0)" style="font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:9px;letter-spacing:2px;text-transform:uppercase;color:var(--text-muted);background:none;border:none;cursor:pointer;margin-top:6px;display:block;transition:color 0.2s;" onmouseover="this.style.color=\'var(--gold)\'" onmouseout="this.style.color=\'var(--text-muted)\'">Remove</button>' +
      '</div>' +
    '</div>';
  }).join('');

  footerEl.innerHTML =
    '<div style="display:flex;justify-content:space-between;margin-bottom:16px;">' +
      '<span style="font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:9px;letter-spacing:3px;text-transform:uppercase;color:var(--text-muted);">Subtotal</span>' +
      '<span style="font-family:\'Cinzel\',serif;font-size:16px;color:var(--gold-dark);">$' + (cart.total_price / 100).toFixed(2) + '</span>' +
    '</div>' +
    '<a href="/checkout" style="display:block;width:100%;text-align:center;background:var(--gold);color:var(--ivory);font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:10px;letter-spacing:4px;text-transform:uppercase;padding:15px;transition:background 0.2s;border:none;cursor:pointer;" onmouseover="this.style.background=\'var(--gold-dark)\'" onmouseout="this.style.background=\'var(--gold)\'">Proceed to Checkout</a>' +
    '<a href="/cart" style="display:block;width:100%;text-align:center;color:var(--text-muted);font-family:\'Josefin Sans\',sans-serif;font-weight:100;font-size:9px;letter-spacing:3px;text-transform:uppercase;padding:13px;border:1px solid var(--border);margin-top:10px;transition:border-color 0.2s;" onmouseover="this.style.borderColor=\'var(--gold)\'" onmouseout="this.style.borderColor=\'var(--border)\'">View Cart</a>';
}

function drawerUpdateItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r) { return r.json(); }).then(function(cart) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = cart.item_count;
    renderCartDrawer(cart);
  });
}

function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function() { location.reload(); });
}

// ── TOAST ──
function showToast(name, sub) {
  var t = document.getElementById('toast');
  document.getElementById('toast-name').textContent = name;
  document.getElementById('toast-sub').textContent = sub || '';
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 3000);
}

// ── NAV ──
function toggleMenu() {
  document.getElementById('nav-mobile').classList.toggle('open');
}
window.addEventListener('scroll', function() {
  var nav = document.getElementById('site-nav');
  if (nav) nav.style.boxShadow = window.scrollY > 40 ? '0 4px 30px rgba(184,146,74,0.1)' : '';
});
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') { closeCart(); closeModal(); }
});

// ── REVIEWS CAROUSEL ──
var reviewIdx = 0;
var reviewTotal = 0;
var reviewTimer = null;

function initReviews() {
  var slides = document.querySelectorAll('.review-slide');
  reviewTotal = slides.length;
  if (!reviewTotal) return;
  var dotsEl = document.getElementById('review-dots');
  if (dotsEl) {
    dotsEl.innerHTML = Array.from({ length: reviewTotal }, function(_, i) {
      return '<button class="review-dot ' + (i === 0 ? 'active' : '') + '" onclick="goReview(' + i + ')"></button>';
    }).join('');
  }
  reviewTimer = setInterval(function() { reviewNav(1); }, 5000);
}

function reviewNav(dir) {
  reviewIdx = (reviewIdx + dir + reviewTotal) % reviewTotal;
  goReview(reviewIdx);
}
function goReview(idx) {
  reviewIdx = idx;
  var track = document.getElementById('reviews-track');
  if (track) track.style.transform = 'translateX(-' + (idx * 100) + '%)';
  document.querySelectorAll('.review-dot').forEach(function(d, i) { d.classList.toggle('active', i === idx); });
}

// ── PRODUCT MODAL ──
var modalState = { images: [], qty: 1, nailSize: null, toeSize: null, variants: [], productId: null };

function openModal(card) {
  var images = [];
  try { images = JSON.parse(card.getAttribute('data-images') || '[]'); } catch(e) {}
  if (!images.length) {
    var ci = card.querySelector('.product-img img');
    if (ci) images = [ci.src];
  }
  var variants = [];
  try { variants = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch(e) {}
  modalState = {
    images: images,
    qty: 1,
    nailSize: null,
    toeSize: null,
    variants: variants,
    productId: card.getAttribute('data-product-id')
  };

  var badge = card.getAttribute('data-badge') || '';
  var name = card.getAttribute('data-title') || '';
  var price = card.getAttribute('data-price') || '';
  var desc = card.getAttribute('data-desc') || '';

  var badgeEl = document.getElementById('modal-badge');
  if (badgeEl) { badgeEl.textContent = badge; badgeEl.style.display = badge ? 'block' : 'none'; }
  var nameEl = document.getElementById('modal-name');
  if (nameEl) nameEl.textContent = name;
  var subEl = document.getElementById('modal-sub');
  if (subEl) subEl.textContent = '10 press-on nails · 10 to 14 toe nails · lash · gloss & prep kit';
  var detailEl = document.getElementById('modal-detail');
  if (detailEl) detailEl.textContent = desc;
  var viewLink = document.getElementById('modal-view-link');
  if (viewLink) { var u = card.getAttribute('data-url'); viewLink.href = u || '#'; viewLink.style.display = u ? 'inline-block' : 'none'; }
  var priceEl = document.getElementById('modal-price');
  if (priceEl) priceEl.textContent = price;
  var qtyEl = document.getElementById('modal-qty-val');
  if (qtyEl) qtyEl.textContent = '1';

  document.querySelectorAll('.modal-size-btn').forEach(function(b) { b.classList.remove('active'); });

  buildModalThumbs(images);
  setModalImage(0);
  hideSizeGuide();

  document.getElementById('product-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  document.getElementById('product-modal').classList.remove('open');
  document.body.style.overflow = '';
}

function handleModalOverlayClick(e) {
  if (e.target === document.getElementById('product-modal')) closeModal();
}

function buildModalThumbs(images) {
  var thumbsEl = document.getElementById('modal-thumbs');
  var dotsEl = document.getElementById('modal-dots');
  if (!thumbsEl) return;

  thumbsEl.innerHTML = images.map(function(src, i) {
    return '<div class="modal-thumb ' + (i === 0 ? 'active' : '') + '" onclick="setModalImage(' + i + ')">' +
      '<img src="' + src + '" alt="">' +
    '</div>';
  }).join('') +
  '<div class="modal-thumb-size ' + (false ? 'active' : '') + '" onclick="showSizeGuide()">Size<br>Guide</div>';

  if (dotsEl) {
    dotsEl.innerHTML = Array.from({ length: images.length + 1 }, function(_, i) {
      return '<button class="modal-dot ' + (i === 0 ? 'active' : '') + '" onclick="' + (i < images.length ? 'setModalImage(' + i + ')' : 'showSizeGuide()') + '"></button>';
    }).join('');
  }
}

function setModalImage(idx) {
  var img = document.getElementById('modal-main-img');
  var display = document.getElementById('modal-display');
  var guide = document.getElementById('modal-size-guide');
  if (guide) guide.style.display = 'none';
  if (display) display.style.display = 'block';
  if (img && modalState.images[idx]) img.src = modalState.images[idx];
  document.querySelectorAll('.modal-thumb').forEach(function(t, i) { t.classList.toggle('active', i === idx); });
  document.querySelectorAll('.modal-dot').forEach(function(d, i) { d.classList.toggle('active', i === idx); });
  document.querySelectorAll('.modal-thumb-size').forEach(function(t) { t.classList.remove('active'); });
}

function showSizeGuide() {
  var display = document.getElementById('modal-display');
  var guide = document.getElementById('modal-size-guide');
  if (display) display.style.display = 'none';
  if (guide) {
    guide.style.display = 'block';
    guide.innerHTML = buildSizeGuideHTML();
  }
  document.querySelectorAll('.modal-thumb').forEach(function(t) { t.classList.remove('active'); });
  document.querySelectorAll('.modal-thumb-size').forEach(function(t) { t.classList.add('active'); });
  var dots = document.querySelectorAll('.modal-dot');
  dots.forEach(function(d, i) { d.classList.toggle('active', i === dots.length - 1); });
}

function hideSizeGuide() {
  var display = document.getElementById('modal-display');
  var guide = document.getElementById('modal-size-guide');
  if (display) display.style.display = 'block';
  if (guide) guide.style.display = 'none';
}

function buildSizeGuideHTML() {
  return '<div class="sg-logo">CYNOIRÉ</div>' +
    '<div class="sg-sub">Size Guide</div>' +
    '<div class="sg-section-title">Finger Nails (mm)</div>' +
    '<table class="sg-table"><thead><tr><th>Size</th><th>Thumb</th><th>Index</th><th>Middle</th><th>Ring</th><th>Pinky</th></tr></thead><tbody>' +
    '<tr><td>XS</td><td>14</td><td>10</td><td>11</td><td>10</td><td>8</td></tr>' +
    '<tr><td>S</td><td>15</td><td>11</td><td>12</td><td>11</td><td>9</td></tr>' +
    '<tr class="highlight"><td>M</td><td>16</td><td>12</td><td>13</td><td>12</td><td>10</td></tr>' +
    '<tr><td>L</td><td>17</td><td>13</td><td>14</td><td>13</td><td>11</td></tr>' +
    '</tbody></table>' +
    '<div class="sg-section-title">Toe Nails (mm)</div>' +
    '<table class="sg-table"><thead><tr><th>Size</th><th>Big Toe</th><th>2nd</th><th>3rd</th><th>4th</th><th>Pinky</th></tr></thead><tbody>' +
    '<tr><td>S</td><td>17</td><td>10</td><td>9</td><td>8</td><td>7</td></tr>' +
    '<tr class="highlight"><td>M</td><td>18.5</td><td>11</td><td>10</td><td>9</td><td>8</td></tr>' +
    '<tr><td>L</td><td>20</td><td>12</td><td>11</td><td>10</td><td>9</td></tr>' +
    '</tbody></table>' +
    '<div class="sg-note">Measure nail bed at widest point in mm · Between sizes? Size up</div>';
}

function selectNailSize(btn) {
  document.querySelectorAll('#modal-nail-sizes .modal-size-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  modalState.nailSize = btn.getAttribute('data-size');
}

function selectToeSize(btn) {
  document.querySelectorAll('#modal-toe-sizes .modal-size-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  modalState.toeSize = btn.getAttribute('data-size');
}

function modalQty(delta) {
  modalState.qty = Math.max(1, modalState.qty + delta);
  var el = document.getElementById('modal-qty-val');
  if (el) el.textContent = modalState.qty;
}

function modalAddToCart() {
  if (!modalState.nailSize || !modalState.toeSize) {
    var btn = document.getElementById('modal-add-btn');
    btn.textContent = 'Please select Nail & Toe size';
    setTimeout(function() { btn.textContent = 'Add to Bag'; }, 2500);
    return;
  }
  var btn = document.getElementById('modal-add-btn');
  btn.textContent = 'Adding...';
  var matched = modalState.variants.find(function(v) { return v.option1 === modalState.nailSize; });
  var variantId = matched ? matched.id : (modalState.variants.length ? modalState.variants[0].id : modalState.productId);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { 'Toe Size': modalState.toeSize }
    })
  }).then(function(r) { return r.json(); }).then(function(data) {
    if (data.id) {
      btn.textContent = 'Added';
      updateCartCount();
      var name = document.getElementById('modal-name').textContent;
      showToast(name, 'Nail ' + modalState.nailSize + ' / Toe ' + modalState.toeSize);
      setTimeout(function() { btn.textContent = 'Add to Bag'; closeModal(); openCart(); }, 1200);
    } else {
      showButtonState(btn, data.description || 'Error, try again', 'error');
      setTimeout(function() { btn.textContent = 'Add to Bag'; btn.style.background = ''; btn.style.color = ''; }, 3000);
    }
  }).catch(function() {
    showButtonState(btn, 'Error, try again', 'error');
    setTimeout(function() { btn.textContent = 'Add to Bag'; btn.style.background = ''; btn.style.color = ''; }, 3000);
  });
}

// ── FEEDBACK STATES ──
function showButtonState(btn, text, kind) {
  btn.textContent = text;
  if (kind === 'error') {
    btn.style.background = 'var(--error-bg)';
    btn.style.color = 'var(--error-text)';
  } else if (kind === 'success') {
    btn.style.background = 'var(--success-bg)';
    btn.style.color = 'var(--success-text)';
  }
}

// ── NEWSLETTER ──
function handleNewsletter(e) {
  e.preventDefault();
  var btn = e.target.querySelector('button');
  showButtonState(btn, '✓ Subscribed', 'success');
  setTimeout(function() { btn.textContent = 'Subscribe'; btn.style.background = ''; btn.style.color = ''; e.target.reset(); }, 3000);
}

// ── PRODUCT CARD LINKS ──
// Cards contain real <a href> links (crawlable, shareable, open-in-new-tab).
// A plain click still opens the quick-view modal; modified clicks (cmd/ctrl/
// shift/alt) fall through to normal link behavior.
document.addEventListener('click', function(e) {
  var card = e.target.closest && e.target.closest('.product-card[data-product-id]');
  if (!card) return;
  var link = e.target.closest('a.product-link');
  if (link && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
  e.preventDefault();
  openModal(card);
});

// ── INIT ──
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
  initReviews();
});
